import React from 'react';

function svgArrowDown(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25" width="24" height="25">

      <defs>
        <filter id="prefix__a">
          <feColorMatrix in="SourceGraphic" values="000000" />
        </filter>
      </defs>
      <g filter="url(&quot;#prefix__a&quot;)"
        fill={props.fill}
        // fill-rule="evenodd"
        transform="translate(-473 1)">
        <path
          // fill="#2d3436"
          fill={props.fill}
          // fill-rule="nonzero"
          d="M 492.741 7.765 c 0.32 0.325 0.343 0.835 0.072 1.188 l -0.074 0.085 l -7.126 7.2 c -0.32 0.323 -0.822 0.347 -1.17 0.073 l -0.084 -0.075 l -7.1 -7.2 c -0.346 -0.351 -0.346 -0.92 0 -1.272 c 0.32 -0.325 0.824 -0.35 1.172 -0.075 l 0.084 0.075 l 6.473 6.564 l 6.498 -6.566 c 0.32 -0.323 0.824 -0.347 1.172 -0.072 l 0.083 0.075 Z" />
      </g>
    </svg>
  );
}

export default svgArrowDown;
